import React from 'react';
import { AnimatedSection, AnimatedItem } from './AnimatedSection';
export function HowItWorksSection() {
  return <section className="w-full bg-navy-800" data-id="element-133">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-20 md:py-28" data-id="element-134">
        <AnimatedSection data-id="element-135">
          <AnimatedItem data-id="element-136">
            <div className="flex items-center gap-3 mb-4" data-id="element-137">
              <div className="h-px flex-1 max-w-[60px] bg-gold-500/40" data-id="element-138" />
              <span className="text-gold-400 text-xs font-body font-semibold tracking-[0.2em] uppercase" data-id="element-139">
                Cómo Funciona
              </span>
            </div>
          </AnimatedItem>

          <AnimatedItem data-id="element-140">
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-white leading-tight mb-12" data-id="element-141">
              3 pasos simples para{' '}
              <span className="text-gold-400" data-id="element-142">generar tu renta mensual</span>
            </h2>
          </AnimatedItem>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-143">
            {/* Step 1 */}
            <AnimatedItem data-id="element-144">
              <div className="relative p-6 md:p-8 rounded-2xl bg-navy-700/50 border border-slate-700/30 h-full" data-id="element-145">
                <div className="absolute -top-4 left-6 w-9 h-9 rounded-full bg-gradient-to-br from-gold-400 to-gold-600 flex items-center justify-center" data-id="element-146">
                  <span className="text-navy-900 font-body font-bold text-sm" data-id="element-147">
                    1
                  </span>
                </div>
                <h3 className="font-display text-xl font-bold text-white mt-3 mb-3" data-id="element-148">
                  Filtro
                </h3>
                <p className="text-slate-300 font-body text-sm leading-relaxed" data-id="element-149">
                  Seleccionas una empresa líder mundial que estarías feliz de
                  poseer. Usamos el Protocolo Triple A para asegurar que solo
                  trabajas con activos de primera clase.
                </p>
              </div>
            </AnimatedItem>

            {/* Step 2 */}
            <AnimatedItem data-id="element-150">
              <div className="relative p-6 md:p-8 rounded-2xl bg-navy-700/50 border border-slate-700/30 h-full" data-id="element-151">
                <div className="absolute -top-4 left-6 w-9 h-9 rounded-full bg-gradient-to-br from-gold-400 to-gold-600 flex items-center justify-center" data-id="element-152">
                  <span className="text-navy-900 font-body font-bold text-sm" data-id="element-153">
                    2
                  </span>
                </div>
                <h3 className="font-display text-xl font-bold text-white mt-3 mb-3" data-id="element-154">
                  Contrato
                </h3>
                <p className="text-slate-300 font-body text-sm leading-relaxed" data-id="element-155">
                  Vendes un compromiso de compra o venta y cobras la "Prima"
                  (dinero real) al instante. El dinero se deposita en tu cuenta
                  el mismo día.
                </p>
              </div>
            </AnimatedItem>

            {/* Step 3 */}
            <AnimatedItem data-id="element-156">
              <div className="relative p-6 md:p-8 rounded-2xl bg-navy-700/50 border border-slate-700/30 h-full" data-id="element-157">
                <div className="absolute -top-4 left-6 w-9 h-9 rounded-full bg-gradient-to-br from-gold-400 to-gold-600 flex items-center justify-center" data-id="element-158">
                  <span className="text-navy-900 font-body font-bold text-sm" data-id="element-159">
                    3
                  </span>
                </div>
                <h3 className="font-display text-xl font-bold text-white mt-3 mb-3" data-id="element-160">
                  Flujo
                </h3>
                <p className="text-slate-300 font-body text-sm leading-relaxed" data-id="element-161">
                  Repites el proceso mensualmente, reinvirtiendo tus ganancias o
                  usándolas para tus gastos actuales. Tu cuenta se convierte en
                  una máquina de rentas.
                </p>
              </div>
            </AnimatedItem>
          </div>

          {/* Connector line (desktop) */}
          <div className="hidden md:block mt-6" data-id="element-162">
            <div className="h-px bg-gradient-to-r from-gold-500/0 via-gold-500/30 to-gold-500/0" data-id="element-163" />
          </div>
        </AnimatedSection>
      </div>

      <div className="h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent" data-id="element-164" />
    </section>;
}